import Create from "./createComponent"
import Prompt from "../components/common/globalInstalls/Prompt.vue"
import PromptWithIcon from "../components/common/globalInstalls/PromptWithIcon.vue"
import SharePrompt from "../components/common/globalInstalls/SharePrompt.vue"
import Toast from "../components/common/globalInstalls/Toast.vue"
import Loading from "../components/common/globalInstalls/Loading.vue"
import FullMask from "../components/common/globalInstalls/FullMask.vue"
import FissionPoster from "../components/common/globalInstalls/FissionPoster.vue"
import Dialog from "../components/common/globalInstalls/Dialog.vue"
import FriendSelectorPrompt from "../components/common/globalInstalls/FriendSelectorPrompt.vue"
import RulePrompt from "../components/common/globalInstalls/RulePrompt.vue"
import SelectAccountPrompt from "../components/common/globalInstalls/SelectAccountPrompt.vue"

/**
 * 扩展vue实例组件（全局可用）
 * 此文件出现的背景是：由于有些地方比如buyitem需要直接出一个弹窗
 * 但实际上用状态去管理，会导致页面状态非常复杂和难以维护
 * 因此对于简单的一些组件，比如alert/prompt推荐在这里直接使用
 * 使用场景：
 * 全局弹窗，不分场合的弹窗，或者不想用状态去维护的弹窗，可以使用此prompt
 * 对于组件内，状态确认的，可以使用原common/prompt组件
 */

let LoadingInstance = null
let FullMaskInstance = null
let DialogInstance = null
let SelectAccountPromptInstance = null

export default {
  install(Vue) {
    Vue.$Prompt = Vue.prototype.$Prompt = props => {
      return Create(Prompt, props).show()
    }

    Vue.$PromptControl = Vue.prototype.$PromptControl = props => {
      return Create(Prompt, props)
    }

    Vue.$PromptWithIcon = Vue.prototype.$PromptWithIcon = props => {
      return Create(PromptWithIcon, props).show()
    }

    Vue.$CallPromptWithIcon = Vue.prototype.$CallPromptWithIcon = props => {
      return Create(PromptWithIcon, props)
    }

    Vue.$SharePrompt = Vue.prototype.$SharePrompt = props => {
      return Create(SharePrompt, props).show()
    }

    Vue.$Toast = Vue.prototype.$Toast = props => {
      return Create(Toast, props)
    }

    Vue.$Loading = Vue.prototype.$Loading = props => {
      if (LoadingInstance) {
        LoadingInstance.remove()
      }
      LoadingInstance = Create(Loading, props)
      return LoadingInstance
    }
    Vue.$FullMask = Vue.prototype.$FullMask = props => {
      if (FullMaskInstance) {
        FullMaskInstance.remove()
      }
      FullMaskInstance = Create(FullMask, props)
      return FullMaskInstance
    }

    Vue.$Dialog = Vue.prototype.$Dialog = props => {
      if (DialogInstance) {
        DialogInstance.remove()
      }
      DialogInstance = Create(Dialog, props)
      return DialogInstance
    }

    Vue.$showFissionPoster = Vue.prototype.$showFissionPoster = props => {
      return Create(FissionPoster, props).show()
    }

    Vue.$FriendSelectorPrompt = Vue.prototype.$FriendSelectorPrompt = props => {
      return Create(FriendSelectorPrompt, props)
    }

    Vue.$RulePrompt = Vue.prototype.$RulePrompt = props => {
      return Create(RulePrompt, props)
    }

    Vue.$SelectAccountPrompt = Vue.prototype.$SelectAccountPrompt = props => {
      if (SelectAccountPromptInstance) return SelectAccountPromptInstance
      SelectAccountPromptInstance = Create(SelectAccountPrompt, props)
      return SelectAccountPromptInstance
    }
  }
}
